import React from 'react';
import { useAtomValue } from 'jotai';
import { Chip as MUIChip, useTheme } from '@mui/material';
import { themeAtom } from '../../Atoms';
import { useIntl } from 'react-intl';

const Chip = function Chip({
  id,
  ref,
  icon,
  label,
  labelColor = undefined,
  labelGrow = false,
  value,
  size = 'medium',
  variant = 'contained',
  color,
  fontSize,
  width,
  height,
}) {
  const intl = useIntl();
  const theme = useTheme();
  const currentTheme = useAtomValue(themeAtom);

  const baseColorHex = color || theme.custom.stringToColor(value || label);
  return (
    <MUIChip
      id={id}
      variant={variant}
      ref={ref}
      size={size}
      icon={icon}
      label={intl.messages[label] || label}
      slotProps={{
        label: { sx: { flexGrow: labelGrow ? 1 : 0, color: labelColor } },
      }}
      sx={{
        ...theme.custom.bgAndColorStyle(baseColorHex, currentTheme),
        width,
        height,
        fontSize,
        borderRadius: '50px',
        border: variant === 'outlined' ? `1.5px solid ${baseColorHex}` : 'none',
      }}
    />
  );
};

export default Chip;
